import React, { useEffect } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Asker from "./screens/Asker";
import Answerer from "./screens/Answerer";
import Over from "./screens/Over";
import Footer from "./components/Footer";
import Result from "./screens/Result";
import Question from "./screens/Question";
import AroundTheHornIntro from "./screens/AroundTheHornIntro";
import FlusterIntro from "./screens/FlusterIntro";
import useWindowSize from "../../components/shared/WindowResize";
import * as gameAction from "../../redux/game/action";
import * as paramsAction from "../../redux/gameParams/actions";
import * as loaderAction from "../../redux/loader/action";
import Socket from "../../socket/socket";
import fluster_game_background_large from "../../assets/images/fluster/fluster_game_background_large.png";
import fluster_game_background_small from "../../assets/images/fluster/fluster_game_background_small.png";
import { end_Game } from "../../components/shared/utils";

const Fluster = (props) => {
  const parameters = _.get(props, "paramsReducer.gameObj.screens");
  const { width } = useWindowSize();
  const room_obj = _.get(props, "gameReducer.roomObj");
  const game_state = _.get(room_obj, "game_state");
  const status = _.get(game_state, "status");
  const users = _.get(room_obj, "users");
  const current_round = _.get(game_state, "current_round");
  const total_rounds = _.get(game_state, "game_parameters.total_rounds");
  const join_code = _.get(room_obj, "join_code");
  const asker = _.get(game_state, "asker");
  const aroundthehorn_winner = _.get(game_state, "aroundthehorn_winner");
  const answerer = _.get(game_state, "answerer");
  const asker_player_details = _.find(users, { player_id: asker });
  const aroundthehorn_winner_player_details = _.find(users, {
    player_id: aroundthehorn_winner,
  });
  const answerer_player_details = _.find(users, { player_id: answerer });
  const question_ob = _.get(game_state, "question");
  const average_points = _.get(game_state, "average_points");
  const points = _.get(game_state, "points");

  const timer = _.get(game_state, "game_parameters.timer");
  const voteArray = _.get(game_state, "vote");
  const questionPoint = _.get(game_state, "question.points");

  useEffect(() => {
    props.setIsLoading(false);
  }, []);

  const onEndGame = () => {
    end_Game(room_obj, props);
  };

  const onTimesUp = () => {
    let data = {
      action: "update-status",
      roomId: room_obj.id,
      tableTopName: "Fluster",
    };
    Socket.sendMessage(data);
  };

  return (
    <div className="fluster-main">
      <img
        src={
          width < 1500
            ? fluster_game_background_small
            : fluster_game_background_large
        }
        alt=""
        className="background-img"
      />
      <div className="main-content">
        {/* <Asker parameters={parameters} /> */}
        {/* <Answerer parameters={parameters} /> */}
        {/* <Question parameters={parameters} status={status} /> */}
        {/* <Result parameters={parameters} /> */}
        {/* <FlusterIntro parameters={parameters} /> */}
        {/* <AroundTheHornIntro parameters={parameters} /> */}
        {/* <Over parameters={parameters} /> */}

        {status === "Asker" && (
          <Asker
            parameters={parameters}
            asker_player_details={asker_player_details}
            average_points={average_points}
            points={points}
          />
        )}
        {status === "Answerer" && (
          <Answerer
            parameters={parameters}
            answerer_player_details={answerer_player_details}
          />
        )}
        {status === "Question" && (
          <Question
            parameters={parameters}
            status={status}
            answerer_player_details={answerer_player_details}
            asker_player_details={asker_player_details}
            question={question_ob}
            timer={timer}
            onTimesUp={onTimesUp}
            voteArray={voteArray}
            questionPoint={questionPoint}
          />
        )}
        {status === "Result" && (
          <Result
            parameters={parameters}
            status={status}
            average_points={average_points}
            answerer_player_details={answerer_player_details}
            asker_player_details={asker_player_details}
          />
        )}
        {status === "FlusterIntro" && (
          <FlusterIntro
            parameters={parameters}
            answerer_player_details={answerer_player_details}
            asker_player_details={asker_player_details}
          />
        )}
        {status === "FlusterQuestion" && (
          <Question
            parameters={parameters}
            asker_player_details={asker_player_details}
            status={status}
            timer={timer}
            onTimesUp={onTimesUp}
            voteArray={voteArray}
            question={question_ob}
            questionPoint={questionPoint}
          />
        )}
        {status === "FlusterResult" && (
          <Result
            parameters={parameters}
            asker_player_details={asker_player_details}
            status={status}
            average_points={average_points}
            answerer_player_details={answerer_player_details}
          />
        )}
        {status === "AroundTheHornIntro" && (
          <AroundTheHornIntro
            parameters={parameters}
            answerer_player_details={answerer_player_details}
          />
        )}
        {status === "AroundTheHornQuestion" && (
          <Question
            parameters={parameters}
            status={status}
            timer={timer}
            onTimesUp={onTimesUp}
            voteArray={voteArray}
            questionPoint={questionPoint}
            question={question_ob}
          />
        )}
        {status === "AroundTheHornResult" && (
          <Result
            parameters={parameters}
            status={status}
            answerer_player_details={answerer_player_details}
            aroundthehorn_winner_player_details={
              aroundthehorn_winner_player_details
            }
          />
        )}
        {status === "Over" && (
          <>
            <Over parameters={parameters} />
          </>
        )}
      </div>
      <Footer
        parameters={parameters}
        current_round={current_round}
        total_rounds={total_rounds}
        join_code={join_code}
        onEndGame={onEndGame}
        onTimesUp={onTimesUp}
        status={status}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Fluster);
